// extracted by mini-css-extract-plugin
export default {"container":"e3-z","heading":"f3-z","links":"g3-z","copy":"h3-z","subCopy":"i3-z","linksLeft":"j3-z","linksCenter":"k3-z","linksRight":"l3-z","link":"m3-z","onlyLink":"n3-z"};